export const views = [
    { icon: "list", name: "Lista", path: "table" },
    { icon: "calendarEvent", name: "Calendario", path: "calendar" },
]

export const dates = [
    { value: "1", label: "Junio 2023" },
    { value: "2", label: "Julio 2023" },
    { value: "3", label: "Agosto 2023" },
]

export const tabs = [
    { label: "Reservaciones del día", path: "/current" },
    { label: "Todas las reservaciones", path: "/all" },
]

export const tabsValet = [
    { label: "Reservaciones del día", path: "/current"},
    { label: "Reservaciones del mes", path: "/currentmonth" },
]

export const tabsDrawer = [
    { label: "Detalle", path: "detail", number: 0 },
    { label: "Pagos", path: "payments", number: 0 },
]

export const roomTabs = [
    { label: "501", timer: "48 horas", value: "501" },
    { label: "502", timer: "18 horas", value: "502" },
    { label: "503", timer: "24 horas", value: "503" },
]

export const reasonsList = [
    { value: "1", label: "Cancelación por parte del huésped" },
    { value: "2", label: "Error en registro de reserva" },
    { value: "3", label: "El huésped no se presentó" },
    { value: "4", label: "Problemas de disponibilidad" },
    { value: "5", label: "Modificación de reserva" },
    { value: "6", label: "Otro" },
]

export const tableItemsEmpty = {
    rows: [
        {
            value: [
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
            ],
        },
        {
            value: [
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
            ],
        },
        {
            value: [
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
            ],
        },
        {
            value: [
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
            ],
        },
        {
            value: [
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
            ],
        },
        {
            value: [
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
            ],
        },
        {
            value: [
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
            ],
        },
        {
            value: [
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
                { value: "" },
            ],
        },
    ],
}
